// Global vars
var pym = require("./lib/pym");
require("./lib/webfonts");
var pymChild;
var renderBarChart = require("./renderBars");

// Initialize the graphic.
var onWindowLoaded = function() {
  document.querySelector("#fallback").remove();

  let size = "small";
  if (window.innerWidth >= 650 && window.innerWidth < 900) {
    size = "medium";
  } else if (window.innerWidth >= 900) {
    size = "big";
  }

  const toggle = function(e) {
    var target = e.srcElement.id;

    switch(target) {
      case "race":
        document.querySelector("#race-charts").style.display = "flex";
        document.querySelector("#age-charts").style.display = "none";
        break;
      case "age":
        document.querySelector("#race-charts").style.display = "none";
        document.querySelector("#age-charts").style.display = "flex";
        break;
    }

    pym.then(child => {
      child.sendHeight();
    });
  }

  document.querySelector("#toggle").addEventListener("change", toggle);

  var renderAllCharts = function() {
    ["race", "age"].forEach(d => {
      let data = window[d.toUpperCase() + "_DATA"];
      let charts = window[d.toUpperCase() + "_CHARTS"];
      
      charts.forEach((c, i) => {
        let labelWidth = window.SETTINGS.labelWidth;
        if (size === "medium" && i % 2 != 0) {
          labelWidth = 0;
        } else if (size === "big" && i % 3 != 0) {
          labelWidth = 0;
        }
        render(data, labelWidth, size, c, d, i);
      });
    });
  };
  renderAllCharts();

  window.addEventListener("resize", () => {

    size = "small";
  if (window.innerWidth >= 650 && window.innerWidth < 900) {
    size = "medium";
  } else if (window.innerWidth >= 900) {
    size = "big";
  }
    renderAllCharts();
  });

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

// Render the graphic(s). Called by pym with the container width.
var render = function(data, labelWidth, size, chart, demographic, index) {
  // Render the chart!
  var container = "#" + demographic + "-chart-" + index;
  var element = document.querySelector(container);
  var width = element.offsetWidth;
  renderBarChart({
    container,
    width,
    data,
    labelWidth,
    size,
    index,
    labelColumn: "label",
    valueColumn: chart
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);